/* ============================================================
   SALBA header menu — hover-intent + smooth open/close.
   The open/close ANIMATION (220ms, 8px travel) lives in the
   header section CSS. This script only decides WHEN `open` is
   added/removed and holds the panel open via the `salba-closing`
   class while its exit animation plays, so closes ease out
   instead of snapping shut.
   ============================================================ */
(function () {
  var OPEN_DELAY  = 70;   // hover-intent grace before opening (ms)
  var CLOSE_DELAY = 180;  // grace before starting to close (ms) — covers small gaps
  var ANIM_MS     = 220;  // must match the CSS close keyframe duration

  function clearTimers(d) {
    if (d._openTimer)  { clearTimeout(d._openTimer);  d._openTimer  = null; }
    if (d._closeTimer) { clearTimeout(d._closeTimer); d._closeTimer = null; }
  }

  function openMenu(d) {
    clearTimers(d);
    if (d._animTimer) { clearTimeout(d._animTimer); d._animTimer = null; }
    d.classList.remove("salba-closing");
    if (!d.hasAttribute("open")) d.setAttribute("open", "true");
  }

  function closeMenu(d) {
    if (!d.hasAttribute("open")) return;
    if (d._animTimer) clearTimeout(d._animTimer);
    d.classList.add("salba-closing"); // triggers the CSS exit animation
    d._animTimer = setTimeout(function () {
      d.removeAttribute("open");
      d.classList.remove("salba-closing");
      // Collapse any nested submenus so they don't reappear pre-opened next time.
      d.querySelectorAll("details[open]").forEach(function (nested) {
        nested.removeAttribute("open");
        nested.classList.remove("salba-closing");
      });
      d._animTimer = null;
    }, ANIM_MS);
  }

  function wire(d) {
    d.addEventListener("mouseenter", function () {
      if (d._closeTimer) { clearTimeout(d._closeTimer); d._closeTimer = null; }
      d._openTimer = setTimeout(function () { openMenu(d); }, OPEN_DELAY);
    });
    d.addEventListener("mouseleave", function () {
      if (d._openTimer) { clearTimeout(d._openTimer); d._openTimer = null; }
      d._closeTimer = setTimeout(function () { closeMenu(d); }, CLOSE_DELAY);
    });
  }

  // Legacy hooks: markup still calls these via inline onmouseover/onmouseleave.
  // Hover state is now handled per-<details> below, so keep them as safe no-ops.
  window.salbaMouseOver = function () {};
  window.salbaMouseOut  = function () {};

  document.addEventListener("DOMContentLoaded", function () {
    var menu = document.querySelector(".salba_header__inline-menu");
    if (!menu) return;
    menu.querySelectorAll("details").forEach(wire);
  });
})();

/* -------------------------------------------------------
   REMOVED: Old 'fetchABSLogin' function
   REMOVED: Old jQuery '#abs-login-button' click handler
   REMOVED: Old Shadow DOM Observer logic
   
   These are now handled exclusively by the new Dealer Bar section.
   -------------------------------------------------------
*/